import { getRequestProfile, updateRequestProfile } from '../../../../api'
import { useNotification, useReloadOnTabReturn } from '../../../../hooks'
import { useAsyncEntity } from '../../../Entity'
import { getRequestTitle } from '../../../Request'
import { getRequestProfilePreparedData } from '../../RequestProfile.utils'

export function useRequestProfileEntity({
  outboundUuid,
  requestId,
  onReloadList,
}) {
  const { handleAddErrorNotification } = useNotification()

  async function getProfileData() {
    return getRequestProfile({ id: requestId, outboundUuid })
  }

  async function updateProfileData(data) {
    return updateRequestProfile({ data, id: requestId, outboundUuid })
      .then(response => {
        onReloadList?.()

        return response
      })
      .catch(error => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')

        throw error
      })
  }

  const {
    entityData,
    handleEntityReload,
    handleEntitySilentReload,
    handleMergeEntityData,
    handleUpdateEntity,
    isInitiated,
    isLoading,
    serverError,
  } = useAsyncEntity({
    entityId: requestId,
    getProfileData,
    updateProfileData,
  })

  useReloadOnTabReturn({ onReload: handleEntitySilentReload })

  const requestData = getRequestProfilePreparedData(entityData)

  return {
    handleEntityReload,
    handleMergeEntityData,
    handleUpdateEntity,
    isInitiated,
    isLoading,
    requestData,
    requestTitle: getRequestTitle({
      requestNumber: requestData?.requestNumber,
      title: requestData?.title,
    }),
    serverError,
  }
}
